import React, {Component} from "react";
import ProductDetails from "./containter/ProductDetails";

export default class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <ProductDetails {...this.props}/>
            </div>
        );
    }
}